if (!customElements.get("th-epigraph-configurator")) {
  class ThEpigraphConfigurator extends HTMLElement {
    constructor() {
      super();

      this.EPIGRAPH_CONFIGURATOR = document.getElementById("epigraphConfigurator");
      this.storePricing = epigraphConfiguratorJSON;
    }

    connectedCallback() {
      setTimeout(() => {
        if (!epigraphConfiguratorJSON || !this.EPIGRAPH_CONFIGURATOR) {return}
        this.attachListeners();
      });
    }

    attachListeners() {
      window.addEventListener("DOMContentLoaded", (event) => {
        this.updateLoaderImage();
      });
      this.EPIGRAPH_CONFIGURATOR.addEventListener("coreApi:ready", (event) => {
        this.updatePricing();
      });
      this.EPIGRAPH_CONFIGURATOR.addEventListener(
        "coreApi:failed",
        this.handleApiFailure.bind(this)
      );
      this.addEventListener("cart:checkout", (event) => {
        this.addItemsToCart(event);
      });
      this.EPIGRAPH_CONFIGURATOR.addEventListener("globalVariant:updated", (event) => {
        this.handleCartMessage(event);
      });
      this.EPIGRAPH_CONFIGURATOR.addEventListener("items:updated", (event) => {
        this.handleCartMessage(event);
      });
    }

    updatePricing() {
      this.objectPricing = this.EPIGRAPH_CONFIGURATOR.api.core.getCurrentPricingInfo();
      Object.entries(this.objectPricing).map(([sku, skuPricingObject]) => {
        Object.entries(skuPricingObject).map(([variant, variantPricing]) => {
          let priceType = 'price';
          let storePriceBySkuAndVariant = this.getStorePriceBySkuAndVariant(sku, variant, priceType);
          if (storePriceBySkuAndVariant) {
            this.objectPricing[sku][variant] = storePriceBySkuAndVariant;
          }
        });
      });
      this.EPIGRAPH_CONFIGURATOR.api.core.updatePricingForAllProducts(this.objectPricing);

      this.objectCompareAtPricing = this.EPIGRAPH_CONFIGURATOR.api.core.getCurrentCompareAtPricingInfo();
      Object.entries(this.objectCompareAtPricing).map(([sku, skuPricingObject]) => {
        Object.entries(skuPricingObject).map(([variant, variantPricing]) => {
          let priceType = 'compareAtPrice';
          let storePriceBySkuAndVariant = this.getStorePriceBySkuAndVariant(sku, variant, priceType);
          if (storePriceBySkuAndVariant) {
            this.objectCompareAtPricing[sku][variant] = storePriceBySkuAndVariant;
          }
        });
      });
      this.EPIGRAPH_CONFIGURATOR.api.core.updateCompareAtPricingForAllProducts(this.objectCompareAtPricing);
    }

    getStorePriceBySkuAndVariant(sku, variant, price) {
      return this.getNested(this.storePricing, sku, variant, price);
    }

    async handleCartMessage(event) {
      let currentCart = await this.EPIGRAPH_CONFIGURATOR.api.core.getCartItemsAsync();
      let cartMessage = this.dataset.defaultInStockMessage;
      let leadTimeMax = 0;
      let leadTimeMin = 0;

      // Process cart items to find the longest lead time for out-of-stock items
      if (currentCart && currentCart.cartItems && currentCart.cartItems.length > 0) {
        currentCart.cartItems.forEach(item => {
          const { skuID, currentVariant } = item;
          
          // Check if the item exists in the epigraph messages
          if (epigraphCartMessagesJSON[skuID] && epigraphCartMessagesJSON[skuID][currentVariant]) {
            const productInfo = epigraphCartMessagesJSON[skuID][currentVariant];
            
            const inventoryQuantity = parseInt(productInfo.inventoryQuantity, 10) || 0;
            
            // Check if item is out of stock
            if (inventoryQuantity <= 0) {
              // Convert lead times to integers (default to 0 if empty or NaN)
              const itemLeadTimeMin = parseInt(productInfo.leadTimeMin, 10) || 0;
              const itemLeadTimeMax = parseInt(productInfo.leadTimeMax, 10) || 0;
              // Check if this item has longer lead times than what we've seen so far
              if (itemLeadTimeMin > leadTimeMin && itemLeadTimeMax > leadTimeMax) {
                // Update cart message if we have a new longest lead time
                if (productInfo.cartMessage) {
                  cartMessage = productInfo.cartMessage;
                }

                leadTimeMin = itemLeadTimeMin;
                leadTimeMax = itemLeadTimeMax;
              } // When item is out of stock and has no lead time, fallback to default out of stock message
              else if (itemLeadTimeMin === 0 || itemLeadTimeMax === 0) {
                cartMessage = this.dataset.defaultOutOfStockMessage;
              }
            }
          }
        });
      }
      
      // Set the cart message
      if (cartMessage) {
        this.EPIGRAPH_CONFIGURATOR.api.core.setCartMessage(cartMessage);
      }
    }
 
    async addItemsToCart(event) {
      let cartItems = this.getNested(event, 'data', 'cartItems');
      let formData = {
        'items': [],
        'note': null
       };
      cartItems.forEach((item) => {
        if (this.getNested(this.storePricing, item.skuID, item.currentVariant, 'variantId')) {
          let data = {
            "id": this.getNested(this.storePricing, item.skuID, item.currentVariant, 'variantId'),
            "quantity": item.count
          }
          formData.items.push(data);
        }
      });
      await this.EPIGRAPH_CONFIGURATOR.api.core.generateShareableLink()
      .then(data => {
        if (data) {
          formData.note = data;
        }
      });
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.fetchCart();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }

    async fetchCart() {
      try {
        const response = await window.fetch("/cart.js");
        if (!response.ok) {
          return;
        }
        const cart = await response.json();
        const event = new CustomEvent('wetheme-toggle-right-drawer', {
          detail: {
            type: "cart",
            forceOpen: true,
            params: {cart},
          },
        });
        setTimeout(() => {
          document.documentElement.dispatchEvent(event);
        }, 1000);
      } catch (e) {
        console.error("Unable to fetch cart: ", e);
      }
    }

    updateLoaderImage() {
      this.mainShadowRoot = this.EPIGRAPH_CONFIGURATOR.shadowRoot;
      this.loaderImgTemp = this.querySelector('template.loaderImage');
      if(!this.mainShadowRoot || !this.loaderImgTemp){return}
      this.loaderImg = this.loaderImgTemp.innerHTML;
      this.logoSlot = this.mainShadowRoot.querySelector('slot[name="loading-logo"]');
      if (this.logoSlot && this.loaderImg) {
        this.logoSlot.innerHTML = this.loaderImg;
      }
      
    }
 
    //Utility for nested objects
    getNested(obj, ...args) {
      return args.reduce((obj, level) => obj && obj[level], obj)
    }

    // App Failure
    handleApiFailure() {
      console.error("Failed to initialize core api.");
    }
  }

  customElements.define("th-epigraph-configurator", ThEpigraphConfigurator);
}